<template>
    <Dialog :visible="visible" modal dismissableMask closeOnEscape
        :header="`${affiliateSystem} — Postback URLs`"
        class="w-full md:w-4/5"
        @update:visible="$emit('update:visible', $event)">

        <div class="mb-4 flex flex-col gap-1 text-sm text-gray-400">
            <span v-if="partner"><span class="text-gray-300 font-medium">Partner:</span> {{ partner }}</span>
            <span v-if="loginUrl"><span class="text-gray-300 font-medium">Login URL:</span> {{ loginUrl }}</span>
            <span><span class="text-gray-300 font-medium">SALID:</span> {{ salid }}</span>
        </div>

        <div v-if="templates">
            <PostbackUrlBlock
                :defaultSalid="salid ?? templates.defaultSalid"
                :registerTemplate="templates.registerTemplate"
                :ftdTemplate="templates.ftdTemplate"
                :depositTemplate="templates.depositTemplate"
                :readonly="true"
            />
        </div>
        <div v-else class="text-gray-400 text-sm">
            No postback templates found for "{{ affiliateSystem }}".
        </div>
    </Dialog>
</template>

<script setup>
import { computed } from 'vue';
import PostbackUrlBlock from '@/views/Help/PostbackUrlBlock.vue';
import { getPostbackTemplates } from '@/utils/postback-templates';

const props = defineProps({
    visible:         { type: Boolean, required: true },
    affiliateSystem: { type: String,  required: true },
    salid:           { type: Number,  default: null  },
    partner:         { type: String,  default: null  },
    loginUrl:        { type: String,  default: null  },
});

defineEmits(['update:visible']);

const templates = computed(() => getPostbackTemplates(props.affiliateSystem));
</script>
